// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2hvmA","colBig":"styles_colBig__3A1qw","colSmall":"styles_colSmall__pFB3R"};